<template>
  <div>

    <b-modal id="upload-ranges" title="Upload Ranges" hide-footer centered >
      <b-form style="text-align: left;" @submit.prevent="processFile">

        <b-form-group label="Range Name:">
          <b-input required type="text" v-model="rangeName" placeholder="range name"></b-input>
        </b-form-group>

        <b-form-group label="Description:">
          <b-input required type="text" v-model="description" placeholder="description"></b-input>
        </b-form-group>

        <b-form-group label="Select an excel file:">
          <b-form-file
            accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            v-model="file"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
            required
          ></b-form-file>
        </b-form-group>

        <p>If the range name matches a range set already in the system the existing range set will be updated.</p>

        <b-button type="submit">Upload</b-button>
      </b-form>
    </b-modal>

  </div>
</template>

<script>
import { mapActions } from "vuex";

import XLSX from "xlsx";
import { range } from "../modules/api";

export default {
  name: "upload-range",
  data() {
    return {
      file: null,
      rangeName: "",
      description: ""
    };
  },
  methods: {
    async processFile() {

      const text = await this.file.arrayBuffer();
      const workbook = XLSX.read(text, {type: "array"});
      const sheetName = workbook.SheetNames[0];
      let worksheet = workbook.Sheets[sheetName];
      let json = XLSX.utils.sheet_to_json(worksheet);

      let res = await range.createUpdate({
        rangeData: json,
        description: this.description,
        rangeName: this.rangeName
      });

      if (res.data.success) {
        localStorage.removeItem("allRange");
        this.fetchAllRanges();
        this.$bvModal.hide("upload-ranges");
      }

      this.notify({
        message: res.data.message,
        variant: res.data.success ? "success" : "warn"
      });

    },
    ...mapActions(["notify", "fetchAllRanges"])
  }
};
</script>

<style lang="scss" scoped>

</style>